export function inspectFocusedElement(event) {
  const hoveredElement = document.elementFromPoint(event.clientX, event.clientY);
  if (!hoveredElement) {
    return;
  }
  collectCssVarNamesFromElement(hoveredElement);
  collectCssVarNamesFromInlineStyle(hoveredElement);

  const parent = hoveredElement?.parentNode as Element;
  if (!parent || !JSON.parse(localStorage.getItem('ctrlKeyPressed') || 'false')) {
    return;
  }
  collectCssVarNamesFromElement(parent);
  collectCssVarNamesFromInlineStyle(parent);

  const parentOfParent = parent?.parentNode as Element;
  if (!parentOfParent || !JSON.parse(localStorage.getItem('ctrlKeyPressed') || 'false')) {
    return;
  }
  collectCssVarNamesFromElement(parentOfParent);
  collectCssVarNamesFromInlineStyle(parentOfParent);
}

function collectCssVarNamesFromElement(element: Element) {
  const cssVarNames: string[] = [];
  const allCss = [...getMatchedCSSRules(element)];

  for (let i = 0; i < allCss.length; i++) {
    const rules = allCss[i].cssText.substring(allCss[i].cssText.indexOf('{') + 1, allCss[i].cssText.indexOf('}'));
    const r = rules.split(';');
    for (let j = 0; j < r.length; j++) {
      const varName = r[j].trim().split(': ')?.[1];
      if (varName?.includes('var(--')) {
        const regex = /(--(\w*-{0,1})*)/g;
        const matches = varName.match(regex);
        matches.forEach((m) => {
          if (!cssVarNames.includes(m)) {
            cssVarNames.push(m);
          }
        });
      }
    }
  }

  const ctrlKeyPressed = JSON.parse(localStorage.getItem('ctrlKeyPressed') || 'false');
  if (cssVarNames.length && ctrlKeyPressed) {
    console.log('css var names: ', cssVarNames);
    window.top.postMessage(cssVarNames, '*');
  }
}

function collectCssVarNamesFromInlineStyle(element: Element) {
  const cssVarNames: string[] = [];
  const inlineStyle = element.getAttribute('style') || '';
  const inlineStyleRules = `${inlineStyle}`?.trim().split(';');
  if (inlineStyleRules) {
    for (let j = 0; j < inlineStyleRules.length; j++) {
      const varName = inlineStyleRules[j]?.trim()?.split(': ')?.[1];
      if (varName?.includes('var(--')) {
        const regex = /(--(\w*-{0,1})*)/g;
        const matches = varName.match(regex);
        matches.forEach((m) => {
          if (!cssVarNames.includes(m)) {
            cssVarNames.push(m);
          }
        });
      }
    }
  }
  const ctrlKeyPressed = JSON.parse(localStorage.getItem('ctrlKeyPressed') || 'false');
  if (cssVarNames.length && ctrlKeyPressed) {
    console.log('css var names: ', cssVarNames);
    window.top.postMessage(cssVarNames, '*');
  }
}

function getMatchedCSSRules(element: Element): CSSStyleRule[] {
  if (!element) {
    return [];
  }
  const stylesheets = document.styleSheets;
  const result: CSSStyleRule[] = [];
  for (let i = 0; i < stylesheets.length; i++) {
    const rules = stylesheets[i].cssRules;
    for (let j = 0; j < rules.length; j++) {
      if (rules[j] instanceof CSSStyleRule) {
        const rule = rules[j] as CSSStyleRule;
        if (rule.selectorText && element?.matches(rule.selectorText)) {
          result.push(rules[j] as CSSStyleRule);
        }
      }
      if (rules[j] instanceof CSSMediaRule) {
        const rule = rules[j] as CSSMediaRule;
        const mediaRules = rule.cssRules;
        for (let k = 0; k < mediaRules.length; k++) {
          if (mediaRules[k] instanceof CSSStyleRule) {
            const mediaRule = mediaRules[k] as CSSStyleRule;
            if (mediaRule.selectorText && element?.matches(mediaRule.selectorText)) {
              result.push(mediaRules[k] as CSSStyleRule);
            }
          }
        }
      }
    }
  }
  return result;
}
